import type { UniclientPersistence } from '@lemonade-hq/uniclient-chat-client';
import { useGetUniclientPersistence } from '@lemonade-hq/uniclient-chat-client';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUniclientPersistenceErrorMap } from './useUniclientPersistenceErrorMap';

export const useUniclientPersistence = (): UniclientPersistence => {
  const location = useLocation();
  const getUniclientPersistence = useGetUniclientPersistence();
  const errorMap = useUniclientPersistenceErrorMap();

  const { params, error } = useMemo(() => {
    const persistence = getUniclientPersistence({
      pathname: location.pathname,
      search: location.search,
      hostname: window.location.hostname,
      protocol: window.location.protocol,
    });

    return {
      params: persistence.params != null ? { ...persistence.params, errorMap } : null,
      error: persistence.error,
    };
  }, [location, getUniclientPersistence, errorMap]);

  return { params, error };
};
